import "./index.scss";
import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const AffiliateCard = ({ opened = false,  affiliatePost}) => {
  const {name, locationText, intro, websiteLink, image} = affiliatePost
  const img =  getImage(image);

  return (
    <div className="affiliateCard">
      <a href={websiteLink} target="_blank" rel="noreferrer">
        <div class="affiliateCard__image">
          <GatsbyImage image={img} alt={name}/>
        </div>
        <div className='affiliateCard__data'>
          <span>{locationText}</span>
          <h6>{name}</h6>
          <p>{intro}</p>
          <a href={websiteLink} rel="noopener noreferrer" target="_blank">Go to website ›</a>
        </div>
      </a>
    </div>
  )
}

export default AffiliateCard